/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class JwtApiBase {
  AccessToken: Promise<string> | undefined

  protected readonly transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.AccessToken

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }

    return options
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public readonly setAccessToken = (token: Promise<string>) => {
    this.AccessToken = token
  }
}

export interface IAuthorizationClientV1 {

    /**
     * Returns a Pong response.
     * @return Returns a Pong response.
     */
    ping(): Promise<string>;

    /**
     * Returns audit report
     * @return CSV file
     */
    getAuditReport(organizationId: string, from: Date, to: Date): Promise<FileResponse>;

    /**
     * Returns all resources.
     * @param resourceNames (optional) 
     * @param domains (optional) 
     * @param resourceTypes (optional) 
     * @return Returns all resources.
     */
    getResources(pageNumber: number, pageSize: number, resourceNames: string[] | undefined, domains: string[] | undefined, resourceTypes: string[] | undefined): Promise<Resource[]>;

    /**
     * Creates resources based on resources in request body. Only non-existing resources will be created.
     * @return Resources have been created successfully and can be found in the response body.
     */
    createResources(body: Resource[]): Promise<Resource[]>;

    /**
     * Gets roles for a given user.
     * @param userId Id of the user
     * @return Roles can be found in the response body.
     */
    getUserRoles(userId: string): Promise<UserRole[]>;

    /**
     * Updates roles for a given user.
     * @param userId Id of the user
     * @param body (optional) 
     * @return Roles updated.
     */
    updateUserRoles(userId: string, body: RoleGrant[] | undefined): Promise<void>;

    /**
     * Grants a role for a given user.
     * @param userId Id of the user
     * @return Role granted successfully.
     */
    grantUserRole(userId: string, body: RoleGrant): Promise<void>;

    /**
     * Get a list of all user roles for a given organization
     * @param organizationId Id of the organization
     * @return UserRoles can be found in the body of the repsonse.
     */
    getAllOrganizationUserRoles(organizationId: string, pageNumber: number, pageSize: number): Promise<UserRole[]>;

    /**
     * Revokes a role from a user
     * @param userId Id of the user
     * @param roleId Id of the role
     * @param organizationId (optional) Id of the organization
     * @return UserRole revoked successfully.
     */
    revokeUserRole(userId: string, roleId: string, organizationId: string | undefined): Promise<void>;

    /**
     * Gets roles for current user.
     * @return Roles can be found in the response body.
     */
    getCurrentUserRoles(): Promise<UserRole[]>;

    /**
     * Checks access for the current user based on rules in request body.
     * @return User has access to the resource and action.
     */
    checkAccessForCurrentUser(body: AccessCheckRequest): Promise<void>;

    /**
     * Checks access for the current user based on rules in request body.
     * @return Request successful, results can be found in the response body.
     */
    checkAccessForCurrentUserBatch(body: AccessCheckRequest[]): Promise<AccessCheckResponse[]>;

    /**
     * Returns all resource types.
     * @param domains (optional) 
     * @return Returns all resource types.
     */
    getResourceTypes(pageNumber: number, pageSize: number, domains: string[] | undefined): Promise<ResourceType[]>;

    /**
     * Creates resource types based on resource types in request body. Only non-existing resource types will be created.
     * @return Resource types have been created successfully and can be found in the response body.
     */
    createResourceTypes(body: ResourceType[]): Promise<ResourceType[]>;

    /**
     * Returns roles based on paging. Rules can be filtered by organizationId(s), roleName(s)
     * @param roleIds (optional) roleId(s) to query
     * @param organizationIds (optional) organizationId(s) to query
     * @param roleNames (optional) roleName(s) to query
     * @return Returns list of roles.
     */
    getRoles(pageNumber: number, pageSize: number, roleIds: string[] | undefined, organizationIds: string[] | undefined, roleNames: string[] | undefined): Promise<Role[]>;

    /**
     * Creates role based on values in request body.
     * @return Role has been created successfully and can be found in the response body.
     */
    createRole(body: RoleWithoutId): Promise<Role[]>;

    /**
     * Returns the role based on its Id.
     * @param roleId Id of the role
     * @return Returns the role.
     */
    getRoleById(roleId: string): Promise<Role>;

    /**
     * Deletes a role based on its Id.
     * @param roleId Id of the role
     * @return Role deleted successfully.
     */
    deleteRoleById(roleId: string): Promise<void>;

    /**
     * Returns rules based on paging. Rules can be filtered by subjectId(s), subjectName(s), subjectType(s), resourceId(s), resourceName(s), resourceType(s) and/or action(s)
     * @param subjectIds (optional) subjectId(s) to query
     * @param subjectNames (optional) subjectName(s) to query
     * @param subjectTypes (optional) subjectType(s) to query
     * @param resourceIds (optional) resourceId(s) to query
     * @param resourceNames (optional) resourceName(s) to query
     * @param resourceTypes (optional) resourceType(s) to query
     * @param actionTypes (optional) 
     * @param includeExpired (optional) 
     * @return Returns list of rules.
     */
    getRules(pageNumber: number, pageSize: number, subjectIds: string[] | undefined, subjectNames: string[] | undefined, subjectTypes: string[] | undefined, resourceIds: string[] | undefined, resourceNames: string[] | undefined, resourceTypes: string[] | undefined, actionTypes: string[] | undefined, includeExpired: boolean | undefined): Promise<Rule[]>;

    /**
     * Creates rules based on rules in request body. Only non-existing rules will be created.
     * @return Rules have been created successfully and can be found in the response body.
     */
    createRules(body: RuleWithoutId[]): Promise<Rule[]>;

    /**
     * Deletes rules based on rule ids.
     * @return Rules have been marked as deleted successfully.
     */
    deleteRules(ruleIds: string[]): Promise<void>;

    /**
     * Refreshes rule cache.
     * @return Rules have been refreshed successfully.
     */
    refreshRules(): Promise<void>;

    /**
     * Returns the rule based on its Id.
     * @param ruleId Id of the rule
     * @return Returns the rule.
     */
    getRuleById(ruleId: string): Promise<Rule>;

    /**
     * Deletes a rule based on its Id.
     * @param ruleId Id of the rule
     * @return Rule deleted successfully.
     */
    deleteRuleById(ruleId: string): Promise<void>;
}

export class AuthorizationClientV1 extends JwtApiBase implements IAuthorizationClientV1 {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Returns a Pong response.
     * @return Returns a Pong response.
     */
    ping(): Promise<string> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Returns audit report
     * @return CSV file
     */
    getAuditReport(organizationId: string, from: Date, to: Date): Promise<FileResponse> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/reports/audit?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/csv"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAuditReport(_response);
        });
    }

    protected processGetAuditReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Params were badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Returns all resources.
     * @param resourceNames (optional) 
     * @param domains (optional) 
     * @param resourceTypes (optional) 
     * @return Returns all resources.
     */
    getResources(pageNumber: number, pageSize: number, resourceNames: string[] | undefined, domains: string[] | undefined, resourceTypes: string[] | undefined): Promise<Resource[]> {
        let url_ = this.baseUrl + "/resources?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (resourceNames === null)
            throw new Error("The parameter 'resourceNames' cannot be null.");
        else if (resourceNames !== undefined)
            resourceNames && resourceNames.forEach(item => { url_ += "resourceNames=" + encodeURIComponent("" + item) + "&"; });
        if (domains === null)
            throw new Error("The parameter 'domains' cannot be null.");
        else if (domains !== undefined)
            domains && domains.forEach(item => { url_ += "domains=" + encodeURIComponent("" + item) + "&"; });
        if (resourceTypes === null)
            throw new Error("The parameter 'resourceTypes' cannot be null.");
        else if (resourceTypes !== undefined)
            resourceTypes && resourceTypes.forEach(item => { url_ += "resourceTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResources(_response);
        });
    }

    protected processGetResources(response: Response): Promise<Resource[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Resource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Resource[]>(<any>null);
    }

    /**
     * Creates resources based on resources in request body. Only non-existing resources will be created.
     * @return Resources have been created successfully and can be found in the response body.
     */
    createResources(body: Resource[]): Promise<Resource[]> {
        let url_ = this.baseUrl + "/resources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateResources(_response);
        });
    }

    protected processCreateResources(response: Response): Promise<Resource[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Resource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Resource[]>(<any>null);
    }

    /**
     * Gets roles for a given user.
     * @param userId Id of the user
     * @return Roles can be found in the response body.
     */
    getUserRoles(userId: string): Promise<UserRole[]> {
        let url_ = this.baseUrl + "/users/{userId}/roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserRoles(_response);
        });
    }

    protected processGetUserRoles(response: Response): Promise<UserRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRole[]>(<any>null);
    }

    /**
     * Updates roles for a given user.
     * @param userId Id of the user
     * @param body (optional) 
     * @return Roles updated.
     */
    updateUserRoles(userId: string, body: RoleGrant[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserRoles(_response);
        });
    }

    protected processUpdateUserRoles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Grants a role for a given user.
     * @param userId Id of the user
     * @return Role granted successfully.
     */
    grantUserRole(userId: string, body: RoleGrant): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrantUserRole(_response);
        });
    }

    protected processGrantUserRole(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get a list of all user roles for a given organization
     * @param organizationId Id of the organization
     * @return UserRoles can be found in the body of the repsonse.
     */
    getAllOrganizationUserRoles(organizationId: string, pageNumber: number, pageSize: number): Promise<UserRole[]> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/user-roles?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllOrganizationUserRoles(_response);
        });
    }

    protected processGetAllOrganizationUserRoles(response: Response): Promise<UserRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse role id.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRole[]>(<any>null);
    }

    /**
     * Revokes a role from a user
     * @param userId Id of the user
     * @param roleId Id of the role
     * @param organizationId (optional) Id of the organization
     * @return UserRole revoked successfully.
     */
    revokeUserRole(userId: string, roleId: string, organizationId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/roles/{roleId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRevokeUserRole(_response);
        });
    }

    protected processRevokeUserRole(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse role id.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Gets roles for current user.
     * @return Roles can be found in the response body.
     */
    getCurrentUserRoles(): Promise<UserRole[]> {
        let url_ = this.baseUrl + "/users/me/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserRoles(_response);
        });
    }

    protected processGetCurrentUserRoles(response: Response): Promise<UserRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserRole[]>(<any>null);
    }

    /**
     * Checks access for the current user based on rules in request body.
     * @return User has access to the resource and action.
     */
    checkAccessForCurrentUser(body: AccessCheckRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/me/rules/check-access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckAccessForCurrentUser(_response);
        });
    }

    protected processCheckAccessForCurrentUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Checks access for the current user based on rules in request body.
     * @return Request successful, results can be found in the response body.
     */
    checkAccessForCurrentUserBatch(body: AccessCheckRequest[]): Promise<AccessCheckResponse[]> {
        let url_ = this.baseUrl + "/users/me/rules/check-access/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckAccessForCurrentUserBatch(_response);
        });
    }

    protected processCheckAccessForCurrentUserBatch(response: Response): Promise<AccessCheckResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessCheckResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform any of the requested actions.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessCheckResponse[]>(<any>null);
    }

    /**
     * Returns all resource types.
     * @param domains (optional) 
     * @return Returns all resource types.
     */
    getResourceTypes(pageNumber: number, pageSize: number, domains: string[] | undefined): Promise<ResourceType[]> {
        let url_ = this.baseUrl + "/resource-types?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (domains === null)
            throw new Error("The parameter 'domains' cannot be null.");
        else if (domains !== undefined)
            domains && domains.forEach(item => { url_ += "domains=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResourceTypes(_response);
        });
    }

    protected processGetResourceTypes(response: Response): Promise<ResourceType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceType[]>(<any>null);
    }

    /**
     * Creates resource types based on resource types in request body. Only non-existing resource types will be created.
     * @return Resource types have been created successfully and can be found in the response body.
     */
    createResourceTypes(body: ResourceType[]): Promise<ResourceType[]> {
        let url_ = this.baseUrl + "/resource-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateResourceTypes(_response);
        });
    }

    protected processCreateResourceTypes(response: Response): Promise<ResourceType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceType[]>(<any>null);
    }

    /**
     * Returns roles based on paging. Rules can be filtered by organizationId(s), roleName(s)
     * @param roleIds (optional) roleId(s) to query
     * @param organizationIds (optional) organizationId(s) to query
     * @param roleNames (optional) roleName(s) to query
     * @return Returns list of roles.
     */
    getRoles(pageNumber: number, pageSize: number, roleIds: string[] | undefined, organizationIds: string[] | undefined, roleNames: string[] | undefined): Promise<Role[]> {
        let url_ = this.baseUrl + "/roles?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (roleIds === null)
            throw new Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            roleIds && roleIds.forEach(item => { url_ += "roleIds=" + encodeURIComponent("" + item) + "&"; });
        if (organizationIds === null)
            throw new Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "organizationIds=" + encodeURIComponent("" + item) + "&"; });
        if (roleNames === null)
            throw new Error("The parameter 'roleNames' cannot be null.");
        else if (roleNames !== undefined)
            roleNames && roleNames.forEach(item => { url_ += "roleNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<Role[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Role.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Params were badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role[]>(<any>null);
    }

    /**
     * Creates role based on values in request body.
     * @return Role has been created successfully and can be found in the response body.
     */
    createRole(body: RoleWithoutId): Promise<Role[]> {
        let url_ = this.baseUrl + "/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRole(_response);
        });
    }

    protected processCreateRole(response: Response): Promise<Role[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Role.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role[]>(<any>null);
    }

    /**
     * Returns the role based on its Id.
     * @param roleId Id of the role
     * @return Returns the role.
     */
    getRoleById(roleId: string): Promise<Role> {
        let url_ = this.baseUrl + "/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoleById(_response);
        });
    }

    protected processGetRoleById(response: Response): Promise<Role> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Role.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse role id.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No role found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Role>(<any>null);
    }

    /**
     * Deletes a role based on its Id.
     * @param roleId Id of the role
     * @return Role deleted successfully.
     */
    deleteRoleById(roleId: string): Promise<void> {
        let url_ = this.baseUrl + "/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRoleById(_response);
        });
    }

    protected processDeleteRoleById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse role id.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No role found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Returns rules based on paging. Rules can be filtered by subjectId(s), subjectName(s), subjectType(s), resourceId(s), resourceName(s), resourceType(s) and/or action(s)
     * @param subjectIds (optional) subjectId(s) to query
     * @param subjectNames (optional) subjectName(s) to query
     * @param subjectTypes (optional) subjectType(s) to query
     * @param resourceIds (optional) resourceId(s) to query
     * @param resourceNames (optional) resourceName(s) to query
     * @param resourceTypes (optional) resourceType(s) to query
     * @param actionTypes (optional) 
     * @param includeExpired (optional) 
     * @return Returns list of rules.
     */
    getRules(pageNumber: number, pageSize: number, subjectIds: string[] | undefined, subjectNames: string[] | undefined, subjectTypes: string[] | undefined, resourceIds: string[] | undefined, resourceNames: string[] | undefined, resourceTypes: string[] | undefined, actionTypes: string[] | undefined, includeExpired: boolean | undefined): Promise<Rule[]> {
        let url_ = this.baseUrl + "/rules?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (subjectIds === null)
            throw new Error("The parameter 'subjectIds' cannot be null.");
        else if (subjectIds !== undefined)
            subjectIds && subjectIds.forEach(item => { url_ += "subjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (subjectNames === null)
            throw new Error("The parameter 'subjectNames' cannot be null.");
        else if (subjectNames !== undefined)
            subjectNames && subjectNames.forEach(item => { url_ += "subjectNames=" + encodeURIComponent("" + item) + "&"; });
        if (subjectTypes === null)
            throw new Error("The parameter 'subjectTypes' cannot be null.");
        else if (subjectTypes !== undefined)
            subjectTypes && subjectTypes.forEach(item => { url_ += "subjectTypes=" + encodeURIComponent("" + item) + "&"; });
        if (resourceIds === null)
            throw new Error("The parameter 'resourceIds' cannot be null.");
        else if (resourceIds !== undefined)
            resourceIds && resourceIds.forEach(item => { url_ += "resourceIds=" + encodeURIComponent("" + item) + "&"; });
        if (resourceNames === null)
            throw new Error("The parameter 'resourceNames' cannot be null.");
        else if (resourceNames !== undefined)
            resourceNames && resourceNames.forEach(item => { url_ += "resourceNames=" + encodeURIComponent("" + item) + "&"; });
        if (resourceTypes === null)
            throw new Error("The parameter 'resourceTypes' cannot be null.");
        else if (resourceTypes !== undefined)
            resourceTypes && resourceTypes.forEach(item => { url_ += "resourceTypes=" + encodeURIComponent("" + item) + "&"; });
        if (actionTypes === null)
            throw new Error("The parameter 'actionTypes' cannot be null.");
        else if (actionTypes !== undefined)
            actionTypes && actionTypes.forEach(item => { url_ += "actionTypes=" + encodeURIComponent("" + item) + "&"; });
        if (includeExpired === null)
            throw new Error("The parameter 'includeExpired' cannot be null.");
        else if (includeExpired !== undefined)
            url_ += "includeExpired=" + encodeURIComponent("" + includeExpired) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRules(_response);
        });
    }

    protected processGetRules(response: Response): Promise<Rule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Rule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Params were badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Rule[]>(<any>null);
    }

    /**
     * Creates rules based on rules in request body. Only non-existing rules will be created.
     * @return Rules have been created successfully and can be found in the response body.
     */
    createRules(body: RuleWithoutId[]): Promise<Rule[]> {
        let url_ = this.baseUrl + "/rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRules(_response);
        });
    }

    protected processCreateRules(response: Response): Promise<Rule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Rule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Rule[]>(<any>null);
    }

    /**
     * Deletes rules based on rule ids.
     * @return Rules have been marked as deleted successfully.
     */
    deleteRules(ruleIds: string[]): Promise<void> {
        let url_ = this.baseUrl + "/rules?";
        if (ruleIds === undefined || ruleIds === null)
            throw new Error("The parameter 'ruleIds' must be defined and cannot be null.");
        else
            ruleIds && ruleIds.forEach(item => { url_ += "ruleIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRules(_response);
        });
    }

    protected processDeleteRules(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Request body was badly formed. More information in the body of the response.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Refreshes rule cache.
     * @return Rules have been refreshed successfully.
     */
    refreshRules(): Promise<void> {
        let url_ = this.baseUrl + "/rules/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefreshRules(_response);
        });
    }

    protected processRefreshRules(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You are not allowed to perform this request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Returns the rule based on its Id.
     * @param ruleId Id of the rule
     * @return Returns the rule.
     */
    getRuleById(ruleId: string): Promise<Rule> {
        let url_ = this.baseUrl + "/rules/{ruleId}";
        if (ruleId === undefined || ruleId === null)
            throw new Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRuleById(_response);
        });
    }

    protected processGetRuleById(response: Response): Promise<Rule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Rule.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse rule id.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No rule found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Rule>(<any>null);
    }

    /**
     * Deletes a rule based on its Id.
     * @param ruleId Id of the rule
     * @return Rule deleted successfully.
     */
    deleteRuleById(ruleId: string): Promise<void> {
        let url_ = this.baseUrl + "/rules/{ruleId}";
        if (ruleId === undefined || ruleId === null)
            throw new Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{ruleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRuleById(_response);
        });
    }

    protected processDeleteRuleById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Failed to parse rule id.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to consume this endpoint", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No rule found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AccessCheckRequest implements IAccessCheckRequest {
    resourceId!: string;
    action!: string;

    constructor(data?: IAccessCheckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["ResourceId"];
            this.action = _data["Action"];
        }
    }

    static fromJS(data: any): AccessCheckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccessCheckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResourceId"] = this.resourceId;
        data["Action"] = this.action;
        return data;
    }
}

export interface IAccessCheckRequest {
    resourceId: string;
    action: string;
}

export class AccessCheckResponse implements IAccessCheckResponse {
    resourceId!: string;
    action!: string;
    hasAccess!: boolean;

    constructor(data?: IAccessCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["ResourceId"];
            this.action = _data["Action"];
            this.hasAccess = _data["HasAccess"];
        }
    }

    static fromJS(data: any): AccessCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccessCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResourceId"] = this.resourceId;
        data["Action"] = this.action;
        data["HasAccess"] = this.hasAccess;
        return data;
    }
}

export interface IAccessCheckResponse {
    resourceId: string;
    action: string;
    hasAccess: boolean;
}

export class ResourceType implements IResourceType {
    resourceTypeId!: string;
    resourceTypeName!: string;
    domain!: string;

    constructor(data?: IResourceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceTypeId = _data["ResourceTypeId"];
            this.resourceTypeName = _data["ResourceTypeName"];
            this.domain = _data["Domain"];
        }
    }

    static fromJS(data: any): ResourceType {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResourceTypeId"] = this.resourceTypeId;
        data["ResourceTypeName"] = this.resourceTypeName;
        data["Domain"] = this.domain;
        return data;
    }
}

export interface IResourceType {
    resourceTypeId: string;
    resourceTypeName: string;
    domain: string;
}

export class Resource implements IResource {
    resourceId!: string;
    resourceName!: string;
    resourceTypeId!: string;

    constructor(data?: IResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["ResourceId"];
            this.resourceName = _data["ResourceName"];
            this.resourceTypeId = _data["ResourceTypeId"];
        }
    }

    static fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        let result = new Resource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResourceId"] = this.resourceId;
        data["ResourceName"] = this.resourceName;
        data["ResourceTypeId"] = this.resourceTypeId;
        return data;
    }
}

export interface IResource {
    resourceId: string;
    resourceName: string;
    resourceTypeId: string;
}

export class RolePattern implements IRolePattern {
    pattern!: string;
    action!: string;

    constructor(data?: IRolePattern) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pattern = _data["Pattern"];
            this.action = _data["Action"];
        }
    }

    static fromJS(data: any): RolePattern {
        data = typeof data === 'object' ? data : {};
        let result = new RolePattern();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Pattern"] = this.pattern;
        data["Action"] = this.action;
        return data;
    }
}

export interface IRolePattern {
    pattern: string;
    action: string;
}

export class RoleGrant implements IRoleGrant {
    roleId!: string;
    organizationId?: string;

    constructor(data?: IRoleGrant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["RoleId"];
            this.organizationId = _data["OrganizationId"];
        }
    }

    static fromJS(data: any): RoleGrant {
        data = typeof data === 'object' ? data : {};
        let result = new RoleGrant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoleId"] = this.roleId;
        data["OrganizationId"] = this.organizationId;
        return data;
    }
}

export interface IRoleGrant {
    roleId: string;
    organizationId?: string;
}

export class UserRole implements IUserRole {
    userId!: string;
    roleId!: string;
    organizationId?: string;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.roleId = _data["RoleId"];
            this.organizationId = _data["OrganizationId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["RoleId"] = this.roleId;
        data["OrganizationId"] = this.organizationId;
        return data;
    }
}

export interface IUserRole {
    userId: string;
    roleId: string;
    organizationId?: string;
}

export class RoleWithoutId implements IRoleWithoutId {
    roleName!: string;
    organizationId?: string;
    isAdministrative!: boolean;
    rolePatterns?: RolePattern[];

    constructor(data?: IRoleWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["RoleName"];
            this.organizationId = _data["OrganizationId"];
            this.isAdministrative = _data["IsAdministrative"];
            if (Array.isArray(_data["RolePatterns"])) {
                this.rolePatterns = [] as any;
                for (let item of _data["RolePatterns"])
                    this.rolePatterns!.push(RolePattern.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new RoleWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoleName"] = this.roleName;
        data["OrganizationId"] = this.organizationId;
        data["IsAdministrative"] = this.isAdministrative;
        if (Array.isArray(this.rolePatterns)) {
            data["RolePatterns"] = [];
            for (let item of this.rolePatterns)
                data["RolePatterns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleWithoutId {
    roleName: string;
    organizationId?: string;
    isAdministrative: boolean;
    rolePatterns?: RolePattern[];
}

export class Role extends RoleWithoutId implements IRole {
    roleId?: string;

    constructor(data?: IRole) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roleId = _data["RoleId"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoleId"] = this.roleId;
        super.toJSON(data);
        return data;
    }
}

export interface IRole extends IRoleWithoutId {
    roleId?: string;
}

export class RuleWithoutId implements IRuleWithoutId {
    subjectId!: string;
    resourceId!: string;
    subjectName!: string;
    /** The type ID or type name of the subject. Non relational. just for informational purposes. */
    subjectType!: string;
    resourceName!: string;
    /** The type ID or type name of the resource. Non relational. just for informational purposes. */
    resourceType!: string;
    action!: string;
    expiresAt?: Date;
    policyType!: PolicyType;
    subjectOrganization?: string | undefined;
    resourceOrganization?: string | undefined;

    constructor(data?: IRuleWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.policyType = PolicyType.Policy;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["SubjectId"];
            this.resourceId = _data["ResourceId"];
            this.subjectName = _data["SubjectName"];
            this.subjectType = _data["SubjectType"];
            this.resourceName = _data["ResourceName"];
            this.resourceType = _data["ResourceType"];
            this.action = _data["Action"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
            this.policyType = _data["PolicyType"] !== undefined ? _data["PolicyType"] : PolicyType.Policy;
            this.subjectOrganization = _data["SubjectOrganization"];
            this.resourceOrganization = _data["ResourceOrganization"];
        }
    }

    static fromJS(data: any): RuleWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new RuleWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SubjectId"] = this.subjectId;
        data["ResourceId"] = this.resourceId;
        data["SubjectName"] = this.subjectName;
        data["SubjectType"] = this.subjectType;
        data["ResourceName"] = this.resourceName;
        data["ResourceType"] = this.resourceType;
        data["Action"] = this.action;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["PolicyType"] = this.policyType;
        data["SubjectOrganization"] = this.subjectOrganization;
        data["ResourceOrganization"] = this.resourceOrganization;
        return data;
    }
}

export interface IRuleWithoutId {
    subjectId: string;
    resourceId: string;
    subjectName: string;
    /** The type ID or type name of the subject. Non relational. just for informational purposes. */
    subjectType: string;
    resourceName: string;
    /** The type ID or type name of the resource. Non relational. just for informational purposes. */
    resourceType: string;
    action: string;
    expiresAt?: Date;
    policyType: PolicyType;
    subjectOrganization?: string | undefined;
    resourceOrganization?: string | undefined;
}

export class Rule extends RuleWithoutId implements IRule {
    ruleId?: string;

    constructor(data?: IRule) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ruleId = _data["RuleId"];
        }
    }

    static fromJS(data: any): Rule {
        data = typeof data === 'object' ? data : {};
        let result = new Rule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RuleId"] = this.ruleId;
        super.toJSON(data);
        return data;
    }
}

export interface IRule extends IRuleWithoutId {
    ruleId?: string;
}

export enum PolicyType {
    Policy = "Policy",
    Group = "Group",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* tslint:disable */
/* eslint-disable */